import { render } from "./financial.vue?vue&type=template&id=7081d08e"
import script from "./financial.vue?vue&type=script&lang=js"
export * from "./financial.vue?vue&type=script&lang=js"

import "./financial.vue?vue&type=style&index=0&id=7081d08e&lang=css"

import exportComponent from "/home/runner/work/origins-admin-v2/origins-admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__